module.exports = __webpack_public_path__ + "static/img/ham_2.668978e5.webp";